import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useIntegrationContext } from '../../IntegrationProvider';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Property from '@afosto/app-components-react/Property';
import translations from './translations';

const IntegrationParameters = () => {
  const intl = useIntl();
  const { integration } = useIntegrationContext();
  const paramKeys = Object.keys(integration?.parameters ?? {});

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <Box px={2} pb={2}>
        {paramKeys.map(key => (
          <Property
            label={intl.formatMessage({
              id: `integrationParameters.${key}`,
              defaultMessage: key,
              description: `Label of the integration parameter ${key}`,
            })}
            value={integration.parameters[key]}
          />
        ))}
      </Box>
    </Card>
  );
};

export default IntegrationParameters;
